// The PIN brute-force lockout is enforced server-side (see API pin-lockout).
// The client only renders the countdown the server returns.

/** "MM:SS" for a remaining duration in ms. */
export function formatCountdown(ms: number): string {
  const total = Math.max(0, Math.ceil(ms / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}
